import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_MODELS_QUERY_KEY = 'apa-models';

const getModelsQueryKey = (organizationId?: string) =>
  [APA_MODELS_QUERY_KEY, organizationId] as const;

const getModelsQueryOptions = ({
  organizationId,
  enabled = true,
}: {
  organizationId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getModelsQueryKey(organizationId),
    queryFn: async () => {
      const { data } = await apiClient.apa.getModels({
        organizationId: organizationId!,
      });
      return data;
    },
    enabled: enabled && !!organizationId,
  });

export const useModelsQuery = ({ enabled = true } = {}) => {
  const { currentOrganization } = useOrganizations();

  const { isLoading, data, error, refetch } = useQuery(
    getModelsQueryOptions({ organizationId: currentOrganization?.id, enabled })
  );

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
